import { KuxPackage } from '@kaltura-ott/tvpil';
import { observable } from 'mobx';

export class Package {
  @observable data: KuxPackage;

  constructor(data: KuxPackage) {
    this.data = data;
  }
}
